import styled from 'styled-components'
import bg from './logo.png'

interface LogoProps {
  bg: any
}

export const AccountMenu = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;

  > span {
    color: #fff;
    font-size: 15px;
    text-transform: uppercase;
    font-weight: bold;
  }

  > svg {
    margin-left: 0.5rem;
  }
`
export const HeaderContent = styled.div`
  display: flex;
  justify-content: center;
`
export const NavBar = styled.div.attrs(() => ({
  className: 'navbar'
}))``

export const Logo = styled.div<LogoProps>`
  max-width: 120px;
  max-height: 90px;
  width: auto;
  height: auto;
  object-fit: contain;
`
export const ButtonsBlock = styled.div`
  display: flex;
  margin-top: 11px;
  //justify-content: flex-end;
`
export const HeadLink = styled.div`
  display: flex;
  color: #fff;
  font-size: 15px;
  text-transform: uppercase;
  cursor: pointer;
  margin-top: -11px;
  justify-content: center;
`
export const HeaderButtons = styled.div`
  display: flex;
  margin-top: -3px;
  margin-right: 30px;
`
